/* src/components/ViewportControls.module.css */

.infoOverlay {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-family: Arial, sans-serif;
  line-height: 1.4;
  pointer-events: auto;
  z-index: 15;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.details {
  margin-top: 4px;
  font-size: 12px;
  color: #ddd;
}

.roadSection {
  margin-top: 6px;
}

.controlsBar {
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  gap: 8px;
  align-items: center;
  pointer-events: auto;
  z-index: 15;
}

.btn {
  padding: 8px 14px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.btn:hover:not(:disabled) {
  opacity: 0.9;
}

.btnRefresh {
  composes: btn;
  background: #2196f3;
  font-size: 16px;
}

.btnToggle {
  composes: btn;
  font-size: 16px;
}

.btnToggleActive {
  background: #ff9800;
}

.btnToggleInactive {
  background: #666666;
}

.btnExport {
  composes: btn;
  background: #4caf50;
  font-size: 14px;
}

.btnExport:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.btnDelete {
  composes: btn;
  background: #e53935;
  font-size: 14px;
}

.btnDelete:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.statusText {
  font-size: 12px;
  color: #ccc;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  font-family: Arial, sans-serif;
}
